export default [
  {
    path: "/home",
    redirect: "/home/index",
    component: () => import("@/layouts/HomeLayouts.vue"),
    children: [
      {
        path: "/home/index",
        name: "home",
        component: () => import("@/views/home/index.vue"),
        meta: { title: "首页" },
      },
      {
        path: "/chat/:id",
        name: "chat",
        component: () => import("@/views/chat/index.vue"),
        meta: { title: "会话" },
      },
      {
        path: "/process-workshop",
        name: "process-workshop",
        component: () => import("@/views/process-workshop/index.vue"),
        meta: { title: "流程工坊" },
      },
      {
        path: "/application-tools",
        name: "application-tools",
        component: () => import("@/views/application-tools/index.vue"),
        meta: { title: "应用工具" },
      },
      {
        path: "/application-tools/swiper-image",
        name: "swiper-image",
        component: () =>
          import("@/views/application-tools/swiper-image/index.vue"),
        meta: { title: "预览查看" },
      },
      {
        path: "/data-resources",
        name: "data-resources",
        component: () => import("@/views/data-resources/index.vue"),
        meta: { title: "数据资源" },
      },
      {
        path: "/explore-more",
        name: "explore-more",
        component: () => import("@/views/explore-more/index.vue"),
        meta: { title: "探索更多" },
      },
      
      {
        path: "/moreagent",
        name: "moreagent",
        component: () => import("@/views/more-agent/index.vue"),
        meta: { title: "更多智能体" },
      },
      {
        path: "/zsxf",
        name: "zsxf",
        component: () => import("@/views/zsxf/home/index.vue"),
        meta: { title: "数据列表", keepAlive: true },
      },

      //   {
      //     path: "/zsxf/hotword",
      //     name: "hotword",
      //     component: () => import("@/views/zsxf/hotword/index.vue"),
      //     meta: { title: "热门词汇", keepAlive: true },
      //   },
      {
        path: "/zsxf/detail",
        name: "detail",
        component: () => import("@/views/zsxf/article-detail/index.vue"),
        meta: { title: "详情", keepAlive: true },
      },
    ],
  },
];
